var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        title: "Batch Add",
        visible: _vm.dialogVisible,
        scrollbar: false,
        width: "auto",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        closed: _vm.onClosed,
      },
    },
    [
      _c(
        "div",
        { staticClass: "item" },
        [
          _c("div", { staticClass: "mr10" }, [
            _vm._v("1.Please download User List and Template firstly."),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", icon: "el-icon-download" },
              on: { click: _vm.exportMSLList },
            },
            [_vm._v(" User List ")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", icon: "el-icon-download" },
              on: { click: _vm.downloadTemplate },
            },
            [_vm._v(" Import Template ")]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "mr10" }, [
          _vm._v("2.Fill the data into template and upload it."),
        ]),
        _c("div", { staticClass: "el-uploader-wrap" }, [
          _c(
            "div",
            { staticClass: "el-uploader-inner" },
            [
              _c("div", { staticClass: "el-uploader" }, [
                _c("input", {
                  ref: "upload",
                  staticClass: "upload-input",
                  attrs: { type: "file", accept: ".xlsx,.xls" },
                  on: { change: _vm.handleChange },
                }),
                _c(
                  "div",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.$refs.upload.click()
                      },
                    },
                  },
                  [
                    _c(
                      "el-input",
                      {
                        attrs: {
                          disabled: "",
                          value: _vm.fileName,
                          placeholder: "Please select file",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "append-button",
                            attrs: { slot: "append", type: "text" },
                            slot: "append",
                          },
                          [_vm._v(" " + _vm._s(_vm.buttonLabel) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.disabled },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v(" Upload ")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "upload-progress" },
            [
              _vm.showProgress
                ? _c("el-progress", {
                    attrs: {
                      percentage: _vm.percentage,
                      status: _vm.status,
                      "show-text": false,
                      "stroke-width": 3,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }